<template>
  <div class="m-8 flex items-center justify-center">
    <div
      class="relative flex h-10 w-60 items-center rounded-full bg-gray-200 shadow-sm"
    >
      <div
        class="absolute top-0 h-full w-1/3 rounded-full bg-white shadow-sm transition-all duration-300"
        :class="{
          'left-0': currentPosition === 'left',
          'left-1/3': currentPosition === 'center',
          'left-2/3': currentPosition === 'right',
        }"
      />
      <div class="absolute flex w-full">
        <span
          class="w-1/3 cursor-pointer text-center font-medium text-gray-800 transition-colors duration-300 hover:text-gray-600"
          @click="setPosition('left')"
          >{{ props.leftLabel ?? 'Left' }}</span
        >
        <span
          class="w-1/3 cursor-pointer text-center font-medium text-gray-800 transition-colors duration-300 hover:text-gray-600"
          @click="setPosition('center')"
          >{{ props.centerLabel ?? 'Center' }}</span
        >
        <span
          class="w-1/3 cursor-pointer text-center font-medium text-gray-800 transition-colors duration-300 hover:text-gray-600"
          @click="setPosition('right')"
          >{{ props.rightLabel ?? 'Right' }}</span
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

export type SwitchPosition = 'left' | 'center' | 'right'
const emit = defineEmits<(event: 'change', position: SwitchPosition) => void>()

const props = defineProps<{
  leftLabel?: string
  centerLabel?: string
  rightLabel?: string
}>()

const currentPosition = ref('center')

function setPosition(position: SwitchPosition) {
  currentPosition.value = position
  emit('change', position) // Emit the new position to the parent component if needed
}
</script>
